import React, { useCallback, useRef, useState } from 'react';
import classnames from 'classnames';
import { Flex, Pane, Text } from '@leverege/ui-elements';
import S from './Accordion.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Accordion({
  title = 'Title',
  content = 'Content'
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const onClick = useCallback(() => {
    setOpen(!open);
  }, [open, setOpen]);
  return /*#__PURE__*/_jsxs(Pane, {
    variant: "accordion",
    children: [/*#__PURE__*/_jsxs(Flex, {
      className: S.header,
      onClick: onClick,
      justify: "space-between",
      align: "center",
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "accordionTitle",
        children: title
      }), open ? /*#__PURE__*/_jsx("i", {
        className: classnames(S.icon, 'fa fa-chevron-right fa-rotate-90')
      }) : /*#__PURE__*/_jsx("i", {
        className: classnames(S.icon, 'fa fa-chevron-right')
      })]
    }), /*#__PURE__*/_jsx(Pane, {
      domRef: ref,
      style: {
        height: open ? ref?.current?.scrollHeight || 300 : 0
      },
      className: classnames(S.accordionContent),
      variant: "accordionContent",
      children: content
    })]
  });
}